import { h, Component, ComponentChildren } from 'preact'
import TextButton from '../ui-components/TextButton'

interface Props {
  triggerClass?: string,
  class: string,
  triggerElement?: typeof Component,
  trigger: ComponentChildren,
  children: ComponentChildren
}

interface State {
  isOpen: boolean,
}

export default class extends Component<Props, State> {
  root: null | HTMLElement

  constructor () {
    super()
    this.root = null
    this.documentClick = this.documentClick.bind(this)
  }

  addHandler () {
    window.document.addEventListener('click', this.documentClick)
  }

  removeHandler () {
    window.document.removeEventListener('click', this.documentClick)
  }

  documentClick (e: MouseEvent) {
    function isNode (e: EventTarget | null): e is Node {
      return !!e && 'childNodes' in e
    }
    if (!this.root) return
    if (!isNode(e.target)) return
    if (this.root.contains(e.target)) return
    this.removeHandler()
    this.setState({ isOpen: false })
  }

  render (props: Props) {
    const Trigger = props.triggerElement || TextButton
    return <div className={props.triggerClass} ref={ref => { this.root = ref }}>
      <Trigger
        onClick={() => {
          if (!this.state.isOpen) {
            this.addHandler()
          } else {
            this.removeHandler()
          }
          this.setState({ isOpen: !this.state.isOpen })
        }}>
        {props.trigger}
      </Trigger>
      {this.state.isOpen
        ? <div class={props.class}>
          {props.children}
        </div>
        : null}
    </div>
  }
}
